import { Component } from '@angular/core';
import { NzEmptyModule } from 'ng-zorro-antd/empty';

@Component({
  selector: 'tenant-billing-page',
  standalone: true,
  imports: [NzEmptyModule],
  template: `
    <div class="billing-container">
      <!-- Page Header (matches settings design) -->
      <div class="billing-header">
        <div class="billing-header-content">
          <div>
            <h1 class="billing-title">Billing</h1>
            <p class="billing-subtitle">View and manage your bills and invoices</p>
          </div>
        </div>
      </div>

      <!-- Main Content -->
      <div class="billing-content">
        <div class="billing-main">
          <div class="billing-section">
            <div class="billing-section-header">
              <h2 class="billing-section-title">Bills & Invoices</h2>
              <p class="billing-section-description">
                Your billing history and invoices will appear here once you have been billed.
              </p>
            </div>
            <div class="billing-section-content">
              <div class="billing-empty-wrapper">
                <nz-empty nzNotFoundImage="simple" [nzNotFoundContent]="emptyTpl">
                  <ng-template #emptyTpl>
                    <div class="billing-empty">
                      <span class="fe fe-file-text billing-empty-icon"></span>
                      <h3 class="billing-empty-title">No bills yet</h3>
                      <p class="billing-empty-description">
                        You have not received any bills yet. When we generate a bill for your account,
                        it will show up here and you can view or download it.
                      </p>
                    </div>
                  </ng-template>
                </nz-empty>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .billing-container {
        min-height: 100vh;
        background-color: var(--content-bg);
      }

      .billing-header {
        background-color: var(--header-bg);
        border-bottom: 1px solid var(--header-border);
        padding: 24px 32px;
      }

      .billing-header-content {
        max-width: 1400px;
        margin: 0 auto;
      }

      .billing-title {
        font-size: 28px;
        font-weight: 600;
        color: var(--header-text);
        margin: 0 0 4px 0;
      }

      .billing-subtitle {
        font-size: 14px;
        color: var(--header-text-secondary);
        margin: 0;
      }

      .billing-content {
        max-width: 1400px;
        margin: 0 auto;
        padding: 32px;
        min-height: calc(100vh - 140px);
      }

      .billing-main {
        background-color: var(--page-card-bg);
        border: 1px solid var(--page-card-border);
        border-radius: 12px;
        padding: 32px;
        min-height: 600px;
      }

      .billing-section {
        display: flex;
        flex-direction: column;
        gap: 24px;
      }

      .billing-section-header {
        border-bottom: 1px solid var(--card-border);
        padding-bottom: 16px;
      }

      .billing-section-title {
        font-size: 20px;
        font-weight: 600;
        color: var(--header-text);
        margin: 0 0 4px 0;
      }

      .billing-section-description {
        font-size: 14px;
        color: var(--header-text-secondary);
        margin: 0;
      }

      .billing-section-content {
        flex: 1;
      }

      .billing-empty-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 320px;
        background-color: var(--empty-state-bg);
        border-radius: 8px;
        border: 1px dashed var(--card-border);
      }

      .billing-empty {
        text-align: center;
        padding: 24px;
        max-width: 400px;
      }

      .billing-empty-icon {
        font-size: 48px;
        color: var(--empty-state-icon);
        display: block;
        margin-bottom: 16px;
      }

      .billing-empty-title {
        font-size: 18px;
        font-weight: 600;
        color: var(--header-text);
        margin: 0 0 8px 0;
      }

      .billing-empty-description {
        font-size: 14px;
        color: var(--empty-state-text);
        margin: 0;
        line-height: 1.5;
      }

      @media (max-width: 1024px) {
        .billing-header {
          padding: 16px 24px;
        }

        .billing-title {
          font-size: 24px;
        }

        .billing-content {
          padding: 16px;
        }

        .billing-main {
          padding: 24px;
        }
      }
    `,
  ],
})
export class TenantBillingPageComponent {}
